import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '@/constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    tvStations: [],
    shows: [],
    blackoutContentTemplates: [],
    blackoutContentTemplatesMetadata: {},
    blackoutContentTemplate: {},
    blackoutContentTemplateMetadata: {}
  }
})
  .get({
    action: 'getBlackoutContentTemplates',
    property: 'blackoutContentTemplates',
    queryParams: true,
    path: '/blackout-content-templates/',
    onSuccess: payloadToState('blackoutContentTemplates')
  })
  .get({
    action: 'getTvStationsWithBlackoutTemplates',
    property: 'tvStations',
    path: '/blackout-content-templates/tv-stations',
    onSuccess: payloadToState('tvStations')
  })
  .get({
    action: 'getShowsWithBlackoutTemplate',
    property: 'shows',
    path: '/blackout-content-templates/shows',
    onSuccess: payloadToState('shows')
  })
  .post({
    action: 'createBlackoutContentTemplate',
    property: 'blackoutContentTemplate',
    path: '/blackout-content-template/',
    onSuccess: payloadToState('blackoutContentTemplate')
  })
  .get({
    action: 'getBlackoutContentTemplate',
    property: 'blackoutContentTemplate',
    path: ({ id }) => `/blackout-content-templates/${id}`,
    onSuccess: payloadToState('blackoutContentTemplate')
  })
  .put({
    action: 'updateBlackoutContentTemplate',
    property: 'blackoutContentTemplate',
    path: ({ id }) => `/blackout-content-templates/${id}`,
    onSuccess: payloadToState('blackoutContentTemplate')
  })
  .delete({
    action: 'deleteBlackoutContentTemplate',
    property: 'blackoutContentTemplate',
    path: ({ id }) => `/blackout-content-templates/${id}`,
    beforeRequest: getOptimisticDelete('blackoutContentTemplates'),
    onSuccess: payloadToState('blackoutContentTemplate')
  })
  .getStore()
